import React, { useState } from 'react';
import { useAuth } from '../App';
import { populateDemoData, clearDemoData } from '../lib/api';
import { Button } from './ui/button';
import { toast } from 'sonner';
import { Sparkles, Loader2, X, Eye } from 'lucide-react';

export default function DemoBanner() {
  const { isAuthenticated } = useAuth();
  const [loading, setLoading] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [hasDemo, setHasDemo] = useState(false);

  // Don't show if authenticated or dismissed
  if (isAuthenticated || dismissed) return null;

  const handlePopulateDemo = async () => {
    setLoading(true);
    try {
      const res = await populateDemoData();
      setHasDemo(true);
      toast.success(`Demo data loaded: ${res.data.counts.transactions} transactions, ${res.data.counts.mileage_entries} trips`);
      // Reload the page to show new data
      window.location.reload();
    } catch (error) {
      toast.error('Failed to load demo data');
    } finally {
      setLoading(false);
    }
  };

  const handleClearDemo = async () => {
    setLoading(true);
    try {
      await clearDemoData();
      setHasDemo(false);
      toast.success('Demo data cleared');
      window.location.reload();
    } catch (error) {
      toast.error('Failed to clear demo data');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gradient-to-r from-[hsl(var(--accent))]/10 via-[hsl(var(--accent))]/5 to-transparent border-b border-[hsl(var(--accent))]/20">
      <div className="max-w-[1400px] mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-3">
            <div className="p-1.5 rounded-lg bg-[hsl(var(--accent))]/20">
              <Eye className="w-4 h-4 text-[hsl(var(--accent))]" />
            </div>
            <div>
              <p className="text-sm font-medium">
                Preview Mode
              </p>
              <p className="text-xs text-muted-foreground">
                Explore the app with sample data before signing up
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-2">
            {!hasDemo ? (
              <Button
                size="sm"
                className="bg-[hsl(var(--accent))] hover:bg-[hsl(var(--accent))]/90 text-sm"
                onClick={handlePopulateDemo}
                disabled={loading}
                data-testid="try-demo-btn"
              >
                {loading ? (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <Sparkles className="w-4 h-4 mr-2" />
                )}
                Try with Demo Data
              </Button>
            ) : (
              <Button
                size="sm"
                variant="outline"
                onClick={handleClearDemo}
                disabled={loading}
                data-testid="clear-demo-btn"
              >
                {loading ? (
                  <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <X className="w-4 h-4 mr-2" />
                )}
                Clear Demo
              </Button>
            )}
            <Button
              size="sm"
              variant="ghost"
              onClick={() => setDismissed(true)}
              className="text-muted-foreground"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
